import React, { useState } from 'react';
import ContactModal from './ContactModal';

const ContactButton = ({ 
  offer, 
  category = 'general', 
  buttonText = 'Get Info', 
  buttonStyle = 'primary',
  className = "" 
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getButtonClasses = () => {
    const baseClasses = "px-4 py-2 rounded-lg font-medium transition-colors";
    
    switch (buttonStyle) {
      case 'primary':
        return `${baseClasses} bg-blue-600 text-white hover:bg-blue-700`;
      case 'secondary':
        return `${baseClasses} bg-gray-600 text-white hover:bg-gray-700`;
      case 'success':
        return `${baseClasses} bg-green-600 text-white hover:bg-green-700`;
      case 'outline':
        return `${baseClasses} border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white`;
      default:
        return `${baseClasses} bg-blue-600 text-white hover:bg-blue-700`;
    }
  };

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={`${getButtonClasses()} ${className}`}
      >
        {buttonText}
      </button>
      
      {isModalOpen && (
        <ContactModal
          offer={offer}
          category={category}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default ContactButton;
